import React from "react";
import { Box } from "@chakra-ui/react";

// Filters
import FilterForm from "../components/FilterForm";

// Reports
import OrganizationArrivalRatesPerHour from "./organization/OrganizationArrivalRatesPerHour";
import OrganizationArrivalRatesPerDay from "./organization/OrganizationArrivalRatesPerDay";
import OrganizationArrivalRatesPerService from "./organization/OrganizationArrivalRatesPerService";
import BranchesArrivalRatesPerDay from "./branches/BranchArrivalRatesPerDay";
import BranchesArrivalRatesPerHour from "./branches/BranchArrivalRatesPerHour";
import BranchesArrivalRatesPerService from "./branches/BranchArrivalRatesPerService";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";
import { getReportRangeString } from "../store/helpers";

const FullReport = () => {
  const { reportRange } = useSelector((state) => state.defaultReducer);

  const report = [
    <OrganizationArrivalRatesPerHour />,
    <OrganizationArrivalRatesPerDay />,
    <OrganizationArrivalRatesPerService />,
    <BranchesArrivalRatesPerHour />,
    <BranchesArrivalRatesPerDay />,
    <BranchesArrivalRatesPerService />,
  ];
  return (
    <Box>
      <Helmet>
        <title>
          {getReportRangeString(reportRange)} Arrival Rates Full Report
        </title>
      </Helmet>
      <FilterForm />
      {report.map((a, index) =>
        React.cloneElement(a, {
          key: index,
          
          showFilterForm: 0,
          showTitle: 0,
        })
      )}
    </Box>
  );
};

export default FullReport;
